import styled, { css } from 'styled-components';
import { fontFamily, colors } from 'components/styles/_variables';

export const ChipStyled = styled.div`
  height: 36px;
  width: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${fontFamily.primary};
  font-size: 10px;
  font-weight: 500;
  text-align: center;
  color: ${({ active }) => (active ? '#ffffff' : '#434242')};
  background-color: ${({ active }) =>
    active ? colors.elements.primary : 'transparent'};
  border-radius: 8px;
  border: solid 1px ${({ failed }) => failed ? colors.theme.danger : colors.elements.primary};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  ${({ failed }) => failed && css`
    color: ${colors.theme.danger};
  `}
`;

export const ElementWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledLabel = styled.label`
  font-family: ${fontFamily.primary};
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  letter-spacing: -0.27px;
  margin-left: 10px;
  color: ${({ failed }) => failed ? colors.theme.danger : '#636262'};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;

export const StyledInput = styled.input`
  position: relative;
  width: 12px;
  height: 20px;
  min-width: 20px;
  color: ${({ failed }) => failed ? colors.theme.danger : '#363839'};
  border: 1px solid ${({ failed, checkBorder }) => failed ? colors.theme.danger : !!checkBorder ? colors.elements.primary : '#bdc1c6'};
  border-radius: 4px;
  appearance: none;
  outline: 0;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  transition: background 175ms cubic-bezier(0.1, 0.1, 0.25, 1);
  &::before {
    position: absolute;
    content: '';
    display: block;

    top: 1px;
    left: 6px;
    width: 3px;
    height: 10px;
    border-style: solid;
    border-color: #fff;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
    opacity: 0;
  }
  &:checked {
    color: #fff;
    border-color: ${({ failed }) => failed ? colors.theme.danger : colors.elements.primary};
    background: ${({ failed }) => failed ? colors.theme.danger : colors.elements.primary};
    &::before {
      opacity: 1;
    }
    ~ label::before {
      clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
    }
  }
`;
